import { themedColor } from '@lemonade-hq/cdk';
import styled from 'styled-components';

import soundOff from './assets/sound-off-icon.svg';
import soundOn from './assets/sound-on-icon.svg';

export const Highlight = styled.span`
  color: ${themedColor('primary')};
`;

export const GALAXY_Y_POSITION = 0;

export const MuteToggle = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  margin: 0;
  &:before {
    content: '';
    display: block;
    width: 28px;
    height: 28px;
    background-size: 28px 28px;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #202020;
    background-image: url(${soundOn.src}) !important;
    transition: all 0.2s ease;
    border-radius: 50%;
    border: 1px solid white;
    cursor: pointer;
  }

  &:checked:before {
    background-image: url(${soundOff.src}) !important;
  }
`;
